module.exports = __webpack_public_path__ + "img/flor_1.4133a8b6.svg";